import { apiAdd, apiDelete, apiGet } from "../../../API/Service/apiClient";

export const handleGet_TPLPage = async (  
  {setListLoading,setUploadedLogos}
  ) => {
    setListLoading(true);  
    let data={}
  try {
    const resData = await apiGet("partners_logos", data);         
    setUploadedLogos(resData?.data)    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setListLoading(false);    
  }
};

export const handleSubmit_TPLPage = async (  
  {setLoading,formData,showToast}
  ) => {
  setLoading(true);
  
  try {
    let resData={};
    resData = await apiAdd("partners_logos", formData,{
      contentType: "multipart/form-data"
    });
             
    if(resData?.data > 0){         
      showToast("Logos uploaded successfully","success")
      window.location.reload();
    }else{
      showToast("Something went wrong! Please try again","danger")
    }    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);    
  }
};

export const handleDelete_TPLPage = async (  
  {item,showToast,setUploadedLogos,setActionLoader}
  ) => {
      
  try {
    setActionLoader({deleteId:item?.id})
    const resData = await apiDelete("partners_logos", item);
    if(resData?.data > 0){
      showToast("Deleted successfully", "success");
      setUploadedLogos(prev => prev.filter(el => el.id !== item?.id));
    }else{
      showToast("Something went wrong! Please try again", "danger");  
    }         
    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setActionLoader({})
  }
};